export enum ELeadSourceType {
    NEW_CLIENTS = 'New Clients',
    EXISTING_CLIENTS = 'Existing Clients',
    PAST_CLIENTS = 'Past Clients',
}

export enum EChartType {
    PIE = 'pie',
    BAR = 'bar',
}
